import { styled } from '@mui/material/styles';

export const TableWrapper = styled('div')(({ theme }) => ({
  backgroundColor: '#ffffff',
  border: '1px solid #e0e0e0',
  borderRadius: '8px',
  padding: '16px',
  marginTop: '16px',
  '& table': {
    '& th': {
      borderBottom: '1px solid #e0e0e0',
    },
    '& td': {
      borderBottom: '1px solid #e0e0e0',
    },
  },
}));
